import { css } from '@emotion/react';
import Mixin from '../util/mixin';

export class Fieldobject extends Mixin {
  style({ content }, [fieldname]) {
    return css`
      .rjsf-field.rjsf-field-object.${fieldname} {
        > fieldset,
        > .animate-height fieldset,
        > .form-group > .collapse > .prop-fields,
        > .rjsf-form-group > .collapse > .prop-fields,
        > .form-group > .collapsing > .prop-fields,
        > .rjsf-form-group > .collapsing > .prop-fields,
        > .form-group > .animate-height .prop-fields,
        > .rjsf-form-group > .animate-height .prop-fields,
        > .card > .card-body > fieldset,
        > .card > .card-body > .animate-height fieldset,
        > .card > .card-body > .form-group > .prop-fields,
        > .card > .card-body > .rjsf-form-group > .prop-fields,
        > .card > .card-body > .form-group > .animate-height .prop-fields,
        > .card > .card-body > .rjsf-form-group > .animate-height .prop-fields,
        > .form-group > .prop-fields,
        > .rjsf-form-group > .prop-fields {
          ${content}
        }

        .prop-fields-no-padding > .form-group > .prop-fields,
        .prop-fields-no-padding > .rjsf-form-group > .prop-fields,
        .prop-fields-no-padding > .form-group > .collapse > .prop-fields,
        .prop-fields-no-padding > .rjsf-form-group > .collapse > .prop-fields,
        .prop-fields-no-padding > .form-group > .collapsing > .prop-fields,
        .prop-fields-no-padding > .rjsf-form-group > .collapsing > .prop-fields {
          padding: 0px;
        }
      }

      .rjsf-field.rjsf-field-array.${fieldname} {
        > fieldset > div > .array-cards {
          > .array-item-list {
            ${content}
          }
        }
      }

      .array-item.for-object-row.${fieldname} {
        ${content}
      }
    `;
  }
}

export class FieldobjectGrid extends Mixin {
  style({ $, content }, [fieldname, columns]) {
    const columnEnd = columns + 1;

    return new Fieldobject(fieldname).include(
      $,
      css`
        display: grid;
        grid-template-columns: repeat(${columns}, 1fr);
        grid-template-rows: repeat(2, auto);
        grid-column-gap: 20px;
        grid-row-gap: 0px;

        .file-input > .input-group-text {
          // width: 10em;
        }

        .rjsf-field-description,
        .field-description {
          grid-column: 1 / ${columnEnd};
        }

        .to-col-end {
          grid-column-end: ${columnEnd} !important;
        }

        @media only screen and (max-width: 600px) {
          grid-template-columns: repeat(1, 1fr);
        }

        ${content}
      `
    );
  }
}
